import http from '../utils/api'

export const downloadDocument = (link) =>
  http.get(`download?link=${encodeURIComponent(link)}`)
//export const downloadDocument = link => http.get(`download/"hello"`);

export const sendMessage = (companyEventId, sendMessageRequest) =>
  http.post(`/messaging/toSchedule/${companyEventId}`, sendMessageRequest)
